export function transferDict(allDict, type, key) {
  const dict = allDict?.find((v) => v.dicNo === type)?.data;
  return dict?.find((v) => v.key == key)?.value;
}

export function getDict(allDict, type) {
  const dict = allDict?.find((v) => v.dicNo === type)?.data;
  return dict || [];
}
